import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ShotsComponent } from './shots.component';
@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
    ],
    declarations: [
        ShotsComponent,
    ]
})

export class ShotsModule { }
